import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const NoPaddingButtonLarge = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"noPadding Large button"}
        value={"<Button variant={\"noPadding\"} size={'large'}>Large</Button>"}
      >
        <Button variant={"noPadding"} size={"large"}>
          Large
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default NoPaddingButtonLarge;
